module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-body"
  }, [_c('div', {
    ref: "content",
    staticClass: "content"
  })]), _vm._v(" "), (_vm.noticeType === '2') ? _c('div', {
    staticClass: "page-foot"
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-button', {
    staticClass: "my-primary",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.agree($event)
      }
    }
  }, [_vm._v("同意")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.noticeType === '3') ? _c('div', {
    staticClass: "page-foot"
  }, [_c('flexbox', [_c('flexbox-item', [_c('x-button', {
    staticClass: "my-primary",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.agree($event)
      }
    }
  }, [_vm._v("同意")])], 1), _vm._v(" "), _c('flexbox-item', [_c('x-button', {
    staticClass: "my-warn",
    attrs: {
      "type": "warn"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.notAgree($event)
      }
    }
  }, [_vm._v("不同意")])], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8bdd5c34"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgreeUpdate/index.vue
// module id = 1077
// module chunks = 1